module.exports = __webpack_public_path__ + "img/djyl.ce3d8ff9.png";